
export type DrawerLocation = 'start' | 'end' | 'left' | 'right'

export type DrawerOptions = {
  width?: number | string
  persistent?: boolean
  location?: DrawerLocation
}

export type DrawerPayload = {
  component: string | any              // string key (from registry) or a direct component (shell only)
  props?: Record<string, any>
  onClose?: () => void
  options?: DrawerOptions
}

export type DrawerAPI = {
  open: (p: DrawerPayload) => void
  close: () => void
  register: (name: string, comp: any) => void
  unregister: (name: string) => void
  getComponentInstance: () => any
}

// Internal reference to the live API
let apiRef: DrawerAPI | null = null
const waiters: Array<(api: DrawerAPI) => void> = []

/** Called by the shell once the DrawerHost is mounted */
export function setDrawerHost(api: DrawerAPI) {
  apiRef = api
  // flush waiters (MFE subscribers)
  while (waiters.length) {
    const cb = waiters.shift()
    cb && cb(api)
  }
}

/** Get the live API or throw if not ready */
export function getDrawerHost(): DrawerAPI {
  if (!apiRef) {
    throw new Error('DrawerHost is not ready yet')
  }
  return apiRef
}

/** Subscribe to be notified once the DrawerHost API is ready */
export function whenDrawerHostReady(cb: (api: DrawerAPI) => void) {
  if (apiRef) cb(apiRef)
  else waiters.push(cb)
}
